import React from "react"

type Props = {
  className?: string
}

const FinanceIcon = ({ className }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.0565 7.35824C11.8701 8.17183 11.8701 9.49092 11.0565 10.3045C10.2429 11.1181 8.92379 11.1181 8.11019 10.3045C7.2966 9.49092 7.2966 8.17183 8.11019 7.35824C8.92379 6.54465 10.2429 6.54465 11.0565 7.35824"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5001 11.6517V5.08171C17.5001 4.16087 16.7542 3.41504 15.8334 3.41504H3.33341C2.41258 3.41504 1.66675 4.16087 1.66675 5.08171V12.5817C1.66675 13.5025 2.41258 14.2484 3.33341 14.2484H10.2176"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16675 11.7497H5.83341"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 5.91667H14.9999"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8117 12.4658C11.2525 12.5133 10 13.785 10 15.3567C10 16.9575 11.2983 18.2558 12.8992 18.2558C14.0633 18.2558 15.06 17.5658 15.5208 16.5758"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4341 16.5854C13.8332 16.5854 12.5349 15.2871 12.5349 13.6863C12.5349 12.0854 13.8332 10.7871 15.4341 10.7871C17.0357 10.7871 18.3332 12.0854 18.3332 13.6863C18.3332 15.2871 17.0357 16.5854 15.4341 16.5854"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FinanceIcon
